import { jsonSchema, type UIMessage } from 'ai';

import { type MimDataParts } from 'apis/aiAgents';

export type MimUIMessage = UIMessage<never, MimDataParts>;

/** Agent runs tools; Plan only proposes changes until the user switches to do. */
export type SidekickAgentMode = 'do' | 'plan';

/** Responds with a message to the user.
 *  If choices are available from the output of the LLM,
 *  present them as options for the user to select.
 *  If plan is available then a plan card is presented for the user to confirm.
 */
export const structuredResponseSchema = jsonSchema<{
  message: string;
  choices?: string[];
  plan?: string;
}>({
  type: 'object',
  properties: {
    message: { type: 'string' },
    choices: {
      type: 'array',
      items: { type: 'string' },
    },
    plan: { type: 'string' },
  },
  required: ['message'],
  additionalProperties: false,
});
